<script lang="ts"></script>

<svelte:head>
  <title>Page Not Found - LastMinute</title>
</svelte:head>

<div class="px-6 pt-10 lg:px-8 lg:pt-40">
  <div class="mx-auto max-w-xl sm:align-center sm:flex sm:flex-col">
    <h1 class="text-5xl font-medium text-gray-100 sm:text-center">
      Lost in the
      <span
        class="from-pink-400 via-violet-600 to-cyan-300 bg-gradient-to-r bg-clip-text text-transparent"
      >
        roster
      </span>
      ?
    </h1>
    <p class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-400">
      This page isn’t on the schedule. Let’s help you find your way back to better staffing!
      <a href="/" class="text-violet-400 underline">Go Home</a>
    </p>
  </div>
</div>
